export const en = {
  billing: {
    dialogTrialExpiring: {
      title: 'Free trial expiring',
      descriptionInfo:
        'Your free trial will expire on !{BOLD}!.\nIf you do not add a payment method, the platform will no longer be available after that date. Contact us for a custom plan',
      descriptionWarning:
        'Your free trial will expire in !{BOLD}!.\nIf you do not add a payment method, the platform will no longer be available after that date. Contact us for a custom plan',
      descriptionInfoBold: '{{expiringDate}}',
      descriptionWarningBold: '{{deltaOfDays}} days, {{expiringDate}}',
      addPaymentMethod: 'Add payment method',
      contactUs: 'Contact us',
    },
    trialExpiringBanner: {
      messageInfo:
        'Your free trial will expire on {{expiringDate}}. Add a payment method to continue using Slash after the expiry date',
      messageWarning:
        'Your free trial expires in {{deltaOfDays}} days. Add a payment method to continue using Slash',
      cta: 'Add payment method',
    },
    paymentFailedBanner: {
      message:
        'Payment was unsuccessful. Update your payment method within 7 days to avoid platform suspension.',
      cta: 'Update payment method',
    },
    betaExpiringBanner: {
      message:
        'The Beta trial period will expire on {{expiringDate}}. Activate a plan to continue using Slash after the expiry date',
      cta: 'Contact us',
    },
    subscriptionMissingBanner: {
      message:
        'We were unable to complete the activation of your plan. We apologize for the inconvenience, our team is already working to resolve the issue. In the meantime, you can continue to use Slash normally: access to the platform is guaranteed. For assistance or information, write to us at slash@altermaind.com',
    },
    dialogPaymentFailed: {
      title: 'The platform is suspended',
      description:
        'Payment was unsuccessful. Update your payment method to restore access to Slash or contact us for a custom plan.',
      updatePaymentMethod: 'Update payment method',
      logout: 'Log out',
      contactUs: 'Contact us',
    },
    dialogSubscriptionExpiredAdmin: {
      title: 'The free trial has expired.',
      description: 'To continue using Slash add a payment method or contact us for a custom plan.',
      addPaymentMethod: 'Add payment method',
      logout: 'Log out',
      contactUs: 'Contact us',
    },
    dialogSubscriptionExpiredLearning: {
      title: 'License no longer active',
      description: 'The platform can no longer be used, contact HR for more information.',
      logout: 'Log out',
    },
    dialogSubscriptionBetaExpired: {
      title: 'Activate a plan to continue using Slash',
      description:
        'The 3-month free trial has expired.\nTo continue using Slash and view your organization data, contact us to activate a plan.',
      contactUs: 'Contact us',
      logout: 'Log out',
    },
    dialogSubscriptionMissing: {
      title: 'The platform is temporarily suspended',
      description:
        'We were unable to complete the activation of your plan, so access to the platform has been temporarily disabled.\nA member of our team will contact you shortly to assist you in resolving the issue and restoring access as quickly as possible.\nIn the meantime, you can write to us directly at slash@altermaind.com for immediate support.',
      logout: 'Log out',
    },
  },
};
